<template>
    <div>
        <a-card>
            <div class="text-center" style="margin: 40px 0" v-if="ResultInfo.length===0">
                <img style="margin: auto;width: 90px" src="../../img/empty1.png">
                <p class="size2 mt-3 color-ash">采购结果公告未发布</p>
            </div>
            <div class="text-center" style="margin: 40px 0" v-if="ResultInfo.length>0 && pageList.length===0">
                <img style="margin: auto;width: 90px" src="../../img/empty4.png">
                <p class="size2 mt-3 color-ash">无需缴纳成交服务费</p>
            </div>
            <a-row v-if="pageList.length>0">
                <a-col :span="24">
                    <p class="size5 text-center mt-5 mb-2 bold">贵单位在以下包组中成交，请在采购结果公告发布后的<span
                            class="color-red">三个工作日</span>内缴纳成交服务费！</p>
                    <a-table class="border" ref="table" :columns="columns" :data-source="pageList"
                             :rowKey="record => record.bzid"
                             :pagination="false" :loading="tableLoading">
                            <span slot="fwje" slot-scope="text,record">
                            {{text}}元<span v-if="record.ewjs=='1'" style="color:red">（含税）</span>
                             </span>
                        <span slot="upFile" slot-scope="text, record">
                                <div class="color-red">请扫描上传银行单据，大小不超过1MB</div>
                                <div>
                                    <upload-selector ref="UploadSelector" :referId='record.id' :max=1
                                                     configKey='supplier_pay_service'
                                                     @uploadSuccess="uploadSelectorChange"
                                    />
                                </div>
                            </span>
                           <span slot="action" slot-scope="text,record">
                                     <div>{{record.sfqrdz==='1'?'已确认到账':'未确认到账'}}</div>
                            </span>
                    </a-table>
                    <p class="size5 text-center mt-5 mb-0 bold">服务费缴纳账号</p>
                    <p class="size5 mt-5 mb-0 bold" style="color:red">服务费缴纳账号以采购文件中注明的为准。</p>
                    <table class="fx-form-view mt-2">
                        <tr>
                            <th>开户银行</th>
                            <td>{{agencyBank.bankName}}</td>
                        </tr>
                        <tr>
                            <th>银行账户</th>
                            <td>{{agencyBank.bankAccountName}}</td>
                        </tr>
                        <tr>
                            <th>银行账号</th>
                            <td>{{agencyBank.bankAccount}}</td>
                        </tr>
                    </table>
<!--                    <p class="size5 text-center mt-5 mb-0 bold">成交通知书</p>-->
<!--                    <table class="fx-form-view mt-2">-->
<!--                        <tr>-->
<!--                            <th>提示</th>-->
<!--                            <td>-->
<!--                                <div>代理机构确认成交服务费全部到账后才能开放下载。</div>-->
<!--                            </td>-->
<!--                        </tr>-->
<!--                        <tr>-->
<!--                            <th>成交通知书</th>-->
<!--                            <td>-->
<!--                                <div v-if="isDownLoadFile">-->
<!--                                    <div v-show="tzsId?true:false">-->
<!--                                        <upload-selector ref="UploadSelector1" :referId='tzsId' :max=1-->
<!--                                                         readonly="readonly"-->
<!--                                                         configKey='CLERK.FILE.PDF'-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                    <div v-show="!tzsId?true:false">-->
<!--                                        项目经办人暂未发成交通知书，请耐心等待。-->
<!--                                    </div>-->
<!--&lt;!&ndash;                                    <a-button type="link" @click="downFile">[下载]</a-button>&ndash;&gt;-->
<!--                                </div>-->
<!--                            </td>-->
<!--                        </tr>-->
<!--                    </table>-->
                </a-col>
            </a-row>
        </a-card>
    </div>
</template>
<script>
  import UploadSelector from '@/components/selector/UploadSelector'
  import qs from 'qs'

  export default {
    components: {
      UploadSelector
    },
    props: {
      projectId: {
        type: String,
        required: true
      },
      random: {
        type: String,
        default: '',
        required: false
      }
    },
    created () {
      this.initJjResultInfo()
    },
    watch: {
      random: {
        immediate: false,
        handler (newValue, oldValue) {
          console.log(newValue)
          if (newValue !== oldValue) {
            this.initJjResultInfo()
          }
        }
      }
    },
    name: 'DealServiceInfo',
    data () {
      return {
        pageList: [],
        ResultInfo: [],
        tzsId: '',
        isDownLoadFile: false,
        tableLoading: false,
        agencyBank: '',
        columns: [
          {
            title: '成交包组',
            width: '15%',
            dataIndex: 'bzxh',
          },
          {
            title: '成交金额',
            width: '15%',
            dataIndex: 'zbje',
            customRender: (value,record,index) => {
              if ("1" === this.jcxm){
                if (record.zbxx)
                {
                  return record.zbxx
                }else {
                  return (value && value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')+'元' || '')  // 将整数部分逢三一断
                }
              }else {
                if ("1" !== record.bjlx){
                  return   '按'+record.bjLxText+'计算'
                }else {
                  return (value && value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')+'元' || '')  // 将整数部分逢三一断
                }
              }
            }
          },
          {
            title: '应交服务费',
            width: '15%',
            dataIndex: 'fwje',
            scopedSlots: { customRender: 'fwje' }
          },
          {
            title: '上传凭据',
            width: '40%',
            scopedSlots: { customRender: 'upFile' }
          },
          {
            title: '到账情况',
            width: '15%',
            scopedSlots: { customRender: 'action' }
          }
        ],
        projectName:'',
        jcxm:''
      }
    },
    methods: {
      //加载table的数据
      initData () {
        let that = this
        that.tableLoading = true
        that.$http.get('/api/v1/supplier/LegalResult/getWinLegalSupServiceFee.json?projectId=' + that.projectId).then(function (response) {
          that.tableLoading = false
          if (response.code != 200) {
            return
          }
          that.pageList = response.result.serviceFeeResult
          that.projectName = response.result.projectName
          that.jcxm = response.result.jcxm
          // that.isDownLoadFile = response.result.isDownLoadFile
          that.agencyBank = response.result.agencyBank
          // that.tzsId = response.result.tzsId
          console.log(response.result)
        })
      },
      initJjResultInfo () {
        let that = this
        this.$http.get('/api/v1/supplier/fee/getJjJgAnnounceList.json?projectId=' + that.projectId).then(function (res) {
          if (res.code != 200) {
            return
          }
          if (res.result && res.result.length>0)
          {
            that.ResultInfo = res.result
            that.initData()
          }
        })
      },
      //supplierName
      uploadSelectorChange (fileLength) {
        let that = this
        if (fileLength) {
          const user = this.$ls.get('user')
          let projectName = this.projectName
          if (projectName && user.supplierName) {
            let title = '项目消息'
            let content = user.supplierName + '已上传了' + projectName + '的成交服务费缴纳凭据，请及时确认到账情况。'
            this.$http.get('/api/v1/supplier/bid/send_msg_in_project.json?id=' + this.projectId + '&title=' + title + '&content=' + content).then(function (res) {

            })
          }
        }
      }
    }
  }
</script>

<style scoped>
    .fx-form-view {
        table-layout: auto;
    }

    .fx-form-view th {
        border: 1px solid #e6e6e6;
        background-color: #f9f9f9;
    }

    .fx-form-view td {
        border: 1px solid #e6e6e6;
    }
</style>
